import React from 'react';
import { observer } from 'mobx-react-lite';
import { VariableSizeList as List } from 'react-window';
import Skeleton from '@mui/material/Skeleton';
import AutoSizer from 'react-virtualized-auto-sizer';
import InfiniteLoader from 'react-window-infinite-loader';

const SearchResults = ({
  itemCount,
  itemSize = 68,
  style,
  renderNoResults,
  renderRow,
  store,
  getItemsSize
}) => {
  const { resultMap } = store;
  const ids = [...resultMap.keys()];
  const loadMoreItems = (startIndex, stopIndex) => {
    const iterator = Array.from(
      new Array(stopIndex - startIndex),
      (x, i) => startIndex + i
    );
    const idsToLoad = iterator.reduce((acc, i) => {
      const id = ids[i];
      const res = resultMap.get(id);
      if (res === 0 && res !== 1) {
        acc.push(id);
      }
      return acc;
    }, []);
    return store.loadResult(idsToLoad);
  };

  const isRowLoaded = index => {
    const id = ids[index];
    const result = resultMap.get(id);
    return !!result;
  };

  const Row = ({ index, style }) => {
    const id = ids[index];
    const result = resultMap.get(id);
    if (result === 1 || result === 0) {
      return (
        <div
          key={id}
          className="building-card building-card-loading"
          style={style}
        >
          <Skeleton width="40%" variant="text" />
          <Skeleton width="90%" variant="text" />
        </div>
      );
    }

    const isPicked = store.pickedResults.has(id);

    return renderRow({
      index,
      style,
      data: result,
      isPicked
    });
  };

  if (resultMap.size === 0 && renderNoResults) return renderNoResults();
  return (
    <div style={style} className="results">
      <AutoSizer>
        {({ height, width }) => (
          <InfiniteLoader
            isItemLoaded={isRowLoaded}
            loadMoreItems={loadMoreItems}
            itemCount={itemCount || ids.length}
            threshold={10}
            minimumBatchSize={10}
          >
            {({ onItemsRendered, ref }) => (
              <List
                height={height}
                itemCount={ids.length}
                itemSize={index => {
                  if (getItemsSize) return getItemsSize(index);
                  return itemSize;
                }}
                onItemsRendered={onItemsRendered}
                ref={ref}
                width={width}
              >
                {Row}
              </List>
            )}
          </InfiniteLoader>
        )}
      </AutoSizer>
    </div>
  );
};

export default observer(SearchResults);
